import logo from "../components/images/404Logo.png";
import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useEffect, useState } from "react";

const Art812 = () => {
  const [DataHed, setDataHed] = useState("Project Failure");
  const [Dataapi, setDataapi] = useState(
    "If this message doesn't go away our servers may be having issues."
  );
  async function apiTest() {
    try {
      const response = await fetch("http://api.csfrederick.com/data/100700")
        .catch((err) => {
          setDataHed("Internal Server Error");
          setDataapi("We are having issues with our servers. Try again later.");
        })
        .then((response) => {
          if (response.ok)
            setDataapi("Our servers look good, requested page does not exist.");
        });
      console.log(response);
    } catch (err) {
      setDataHed("Internal Server Error");
      setDataapi("We are having issues with our servers. Try again later.");
    }
  }
  useEffect(() => {
    apiTest();
  }, []);
  return (
    <div className="App" style={{ margin: "-8px" }}>
      <HelmetProvider>
        <Helmet>
          <title>Art Code 812</title>
          <meta
            name="Art Code 812"
            content="Learn more about the art."
            description="Learn more about the art."
            author="Jack Frederick"
          />
        </Helmet>
      </HelmetProvider>
      <Warning></Warning>
      <Navbar></Navbar>
      <header className="Home">
        <p className="Homethick">Learn more about the context of my art.</p>
              <p className="Homesmall">You have been directed to art context code: 812.</p>
              <br></br>
        <p className="Homemid">
          What is a art notice code, and why 812?
              </p>
              <p className="Homesmall fitMe">
                  Art with a notice code 812 are digitally rendered works make in Unreal Engine (5.6 or above) and use MetaHuman plugins. These works have special notices about the works that some may need
to be aware of. I am not required to provide this information, but I believe the this information may be helpful to some. The number attached is arbitrary, but forwards you to the correct notice
                  to the work it relates to.
              </p>
<br />
<p className="Homemid">Overall artist intent:</p>
<p className="Homesmall fitMe">
I aim to create and share emotions, both positive and negative. Expressing thoughts through visual means makes me feel more connected to the world. I do not gain anything other than satisfaction and knowledge from my work. I do not do commissions or sponsorships.
</p>

<br />
<p className="Homemid">Personal wellbeing:</p>
<p className="Homesmall fitMe">
Works of art exaggerate certain emotions while suppressing others. It is up to me, the artist, to decide what combination creates the impact I am attempting to achieve. However, this may not accurately reflect my personal wellbeing. Some works I make are graphic, disturbing, and/or exaggerate negative emotions. While my art may display these qualities, I assure you that my wellbeing is good and that I am okay.
</p>

<br />
<p className="Homemid">No AI Use:</p>
<p className="Homesmall fitMe">
This work contains no AI-generated content in the piece, and no AI-generated photo references were used. Some information about Unreal Engine and bug fixing may have involved AI-assisted research, but other publicly available sources were also used.
</p>

<br />
<p className="Homemid">Redistribution:</p>
<p className="Homesmall fitMe">
This work was created using Unreal Engine (5.6+) and the MetaHuman framework to generate digital characters. These assets are licensed under Epic Games’ terms. Please do not redistribute this work or reuse its assets without permission. If you reference or share this work for personal purposes, please link back to this page and credit the artist. The resulting characters are artistic representations and are not intended to identify or replicate any individual without permission.
</p>

<br />
<p className="Homemid">Proof of art:</p>
<p className="Homesmall fitMe">
Many of my works will have an attached proof of art. This provides proof that the content is not AI-generated or stolen from others. This may include (but is not limited to) a secondary perspective, a work-in-progress version (WIP), or another method showing the development process or work environment. Additional proof can be made available if required.
</p>

<br />
<p className="Homemid">Want to know more?</p>
<p className="Homesmall fitMe">
Reach out! I love to talk and am very open to showing my process and helping others learn how to create and understand art. Check out my contact page, or if you found my art on Instagram, feel free to leave a comment with questions.
</p>

<br />
      </header>
      <Footer></Footer>
    </div>
  );
};

export default Art812;
